








import { Component, Vue, Prop } from 'vue-property-decorator'
import { State, Action, Getter, namespace } from 'vuex-class';
import { CurrentUser } from "@/pitprojekt/models/CurrentUser";
import Snackbar from '@/components/Snackbar.vue'
import { EventBus } from "@/pitprojekt/event-bus";
const AuthModule = namespace('AuthModule')
const SettingsModule = namespace('SettingsModule')

@Component({
  components: {
      Snackbar
    }
})
export default class App extends Vue {

  @AuthModule.Getter('loggedIn') loggedIn!: boolean;
  @SettingsModule.Action('getAllSettings') getAllSettings: any;
  @SettingsModule.Getter('currentUser') currentUser!: CurrentUser;

  isLoading: boolean = false;
  fullScreenLoaderWidth: number = 140;
  fullScreenLoaderHeight: number = 140;

   private showFullScreenLoader():void {
    this.isLoading = true;
  }

  private hideFullScreenLoader():void {
    this.isLoading = false;
  }

  created () {
    EventBus.$on('showFullScreenLoaderEvent', this.showFullScreenLoader);
    EventBus.$on('hideFullScreenLoaderEvent', this.hideFullScreenLoader);

    if (this.loggedIn) {
      this.getAllSettings();
    }

  }

}

